import React from "react";

export default function Process() {
  const steps = [
    {
      id: 1,
      title: " Create Your Account",
      description:
        "Sign up in minutes with your email and get instant access to the GFM platform.",
    },
    {
      id: 2,
      title: " Fund Your Wallet",
      description:
        " Add funds securely to start trading. Choose an amount that suits your comfort level.",
    },
    {
      id: 3,
      title: "Activate a Bot & Start Trading",
      description:
        " Pick a trading bot, sit back, and let it trade for you—smart, automatic, and efficient.",
    },
  ];

  return (
    <div className="max-w-7xl mx-auto xl:px-0 px-5 py-12">
     
      <div className="flex flex-col lg:flex-row gap-4 items-center">
        
        <div className="w-full lg:w-1/2">
         <div className="text-center mb-12">
        <span className="inline-block bg-gradient-to-r from-[#263283] to-[#ed2924] text-white px-3 py-1 rounded-full text-sm font-medium mb-3">
          THE PROCESS
        </span>
        <h2 className="text-4xl font-bold text-gray-900">How It Works</h2>
      </div>
          {steps.map((step) => (
            <div
              key={step.id}
              className="bg-white rounded-md p-4 border border-gray-200 shadow-sm mb-6"
            >
              <div className="flex items-start">
                <span className="flex-shrink-0 bg-gray-100 rounded-full w-8 h-8 flex items-center justify-center text-gray-700 font-semibold mr-4">
                  {step.id}
                </span>
                <div>
                  <h3 className="font-semibold text-gray-700 text-lg mb-2">{step.title}</h3>
                  <p className="text-gray-600 text-base">{step.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="w-full lg:w-1/2">
          <div className="bg-green-50 rounded-lg  flex items-center justify-center relative">
            <img
            className="w-[420px] px-8"
              src="https://azim.hostlin.com/Fortradex/assets/images/resource/process-1.jpg "
              alt="treading"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
